module.exports = __webpack_public_path__ + "img/travelling-thali-brand_application-desktop_views.19501ba5.jpg";